import { render, staticRenderFns } from "./noticemant.vue?vue&type=template&id=42bafced&"
import script from "./noticemant.vue?vue&type=script&lang=js&"
export * from "./noticemant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports